<template>
  <div class="cdu-component">
    <template v-if="brand_white1">
      <headlines v-if="!brand_translux5" :category="'CDU_BACKGROUND_' + backgroundSport1" :isplain="true" class="background-sport bg1" :class="backgroundSport1"></headlines>
      <headlines v-if="!brand_translux5" :category="'CDU_BACKGROUND_' + backgroundSport2" :isplain="true" class="background-sport bg2" :class="backgroundSport2"></headlines>
    </template>
    <template v-else>
      <headlines v-if="!brand_translux5" :category="'CDU_BACKGROUND_' + screenId.toUpperCase()" :isplain="true"></headlines>
    </template>

    <cdu-header v-if="!brand_translux4"></cdu-header>
    <cdu-events></cdu-events>
    <cdu-header v-if="brand_translux4"></cdu-header>

    <headlines v-if="showHeadlinesOnCurrentScreen && showHeadlinesLines > 0"
               v-show="maxRotationIndex === currentRotateIndex"
               :category="'CDU_' + screenId + '_' + showHeadlinesLines + '_LINES'"
               :isplain="false"></headlines>

    <carousel v-if="brand_ultrawide" :category="'CDU_BACKGROUND_ULTRAWIDE_' + screenId" fullscreen></carousel>
    <banner v-if="cduState === 'banner'"></banner>
  </div>
</template>

<script>
  import store from '@/store'
  import lib from '@/library'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import Brands from '@/components/mixins/Brands'
  import SingleEvent from '@/components/mixins/templates/SingleEvent'

  import CduHeader from '@/components/cdu/cduHeader'
  import CduEvents from '@/components/cdu/cduEvents'
  import Headlines from '@/components/cdu/headlines/headlines'
  import Carousel from '@/components/cdu/headlines/carousel'
  import Banner from '@/components/cdu/headlines/banner'

  export default {
    name: 'Cdu',

    mixins: [
      BettingOffer,
      SingleEvent,
      Brands
    ],

    components: {
      CduHeader,
      CduEvents,
      Headlines,
      Banner,
      Carousel
    },

    data () {
      return {
        objPeriodicallyFetchScreenConfigurationTimeout: undefined,
        objPeriodicallyFetchCduEvents: undefined,
        objPeriodicallyFetchBoNavigationHeadlines: undefined
      }
    },

    computed: {
      cduState () {
        return store.getters['cduState/getScreenState']
      },
      showHeadlinesLines () {
        return store.getters['bettingOfferState/getShowHeadlinesLines']
      },
      maxRotationIndex () {
        return store.getters['bettingOfferState/getMaxRotationIndex']
      },
      currentRotateIndex () {
        return store.getters['bettingOfferState/getCurrentRotateIndex']
      },
      showHeadlinesOnCurrentScreen () {
        return this.screenConfiguration && this.screenConfiguration.is2displaymarketingdata
      },
      cduNonPinnedEvents () {
        return store.getters['bettingOfferState/getCduNonPinnedEvents']
      },
      cduNonPinnedEventsPaged () {
        return this.cduNonPinnedEvents.filter(ev => ev.eventPage === this.currentRotateIndex)
      },
      cduOutrightEvents () {
        return store.getters['bettingOfferState/getCduOutrightEvents']
      },
      backgroundSport1 () {
        return this.getSportForHeadline(1)
      },
      backgroundSport2 () {
        return this.getSportForHeadline(2)
      }
    },

    methods: {
      getSportForHeadline (headlineNumber) {
        // TODO This method needs to be revorked as soon as half templates are implemented
        var sport = 'GENERIC'

        if (this.cduSingleEvents.length > 0 || this.cduOutrightEvents.length > 0) {
          var events = []

          if (this.cduSingleEvents.length > 0) events = this.cduSingleEvents
          if (this.cduOutrightEvents.length > 0) events = this.cduOutrightEvents

          switch (headlineNumber) {
            case 1:
              sport = events[0] && events[0].idfosporttype
              break
            case 2:
              sport = (events[1] && events[1].idfosporttype) || 'GENERIC'
              break
            default:
          }
        }

        if (this.cduNonPinnedEventsPaged.length > 0) {
          if (headlineNumber === 1) {
            if (lib.betting.event.areSameSport(this.cduNonPinnedEventsPaged)) {
              sport = this.cduNonPinnedEventsPaged[0].idfosporttype
            }
          }
        }

        if (this.cduOutrightEvents.length > 0) {
          if (headlineNumber === 1) {
            sport = this.cduOutrightEvents[0].idfosporttype
          }
        }

        return sport.replace(/ /g, '').toUpperCase()
      },
      periodicallyFetchScreenConfiguration () {
        clearTimeout(this.objPeriodicallyFetchScreenConfigurationTimeout)
        clearTimeout(this.objPeriodicallyFetchCduEvents)

        store.dispatch('cduState/fetchScreenConfig', this.screenId).then(() => {
          this.periodicallyFetchCduEvents()

          this.objPeriodicallyFetchScreenConfigurationTimeout = setTimeout(() => {
            this.periodicallyFetchScreenConfiguration()
          }, 30000)
        })
      },
      periodicallyFetchCduEvents () {
        clearTimeout(this.objPeriodicallyFetchCduEvents)
        store.dispatch('bettingOfferState/fetchCduEvents', { screenId: this.screenId, displaytemplate: this.$route.params.displaytemplate || 'standard' }).then(() => {
          this.objPeriodicallyFetchCduEvents = setTimeout(() => {
            this.periodicallyFetchCduEvents()
          }, 5000)
        })
      },
      periodicallyFetchBoNavigationHeadlines () {
        clearTimeout(this.objPeriodicallyFetchBoNavigationHeadlines)
        store.dispatch('cduState/fetchBoNavigationHeadlines').then(() => {
          this.objPeriodicallyFetchBoNavigationHeadlines = setTimeout(() => {
            this.periodicallyFetchBoNavigationHeadlines()
          }, 60000)
        })
      }
    },

    mounted () {
      this.periodicallyFetchScreenConfiguration()
      this.periodicallyFetchBoNavigationHeadlines()
    },

    destroyed () {
      clearTimeout(this.objPeriodicallyFetchScreenConfigurationTimeout)
      clearTimeout(this.objPeriodicallyFetchCduEvents)
      clearTimeout(this.objPeriodicallyFetchBoNavigationHeadlines)
    },

    watch: {
      '$route' () {
        store.dispatch('bettingOfferState/cleanAllEvents')
        this.periodicallyFetchScreenConfiguration()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/pages/Cdu.vue